export interface SettingRequest {
    Names: string[];
}

export interface UpdateParameterRequest {
    Name: string;
    Value: string;
}

/**
 * buildUpdateGeneralSettings
 *
 * @description
 * Builds a list matching that expected by the server for a request to update
 * an existing settings.
 */
export function buildUpdateSettings(args: { name: string; value: string }): UpdateParameterRequest {
    return {
        Name: args.name,
        Value: args.value,
    };
}

/**
 * buildSettingsRequest
 *
 * @description
 * Builds an object matching that expected by the server for a create new
 * contact request
 */
export function buildSettingsRequest(args: {
    timeZone: string;
    pushNotification: string;
}): SettingRequest {
    return {
        Names: [args.timeZone, args.pushNotification],
    };
}
